import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './ArquivosDisparos.css';

export default function ArquivosDisparos() {
  const [arquivos, setArquivos] = useState([]);
  const [modoEdicao, setModoEdicao] = useState(null);
  const [carregando, setCarregando] = useState(false);
  const [formulario, setFormulario] = useState({
    nome_arquivo: '',
    tipo_arquivo: 'pdf',
    palavras_chave: '',
    mensagem_confirmacao: '',
    mensagem_envio: '',
    arquivo_real: null
  });

  const carregarArquivos = async () => {
  try {
    const res = await axios.get('/crm-wly/api/openai/ia_arquivos_disparos.php');
    setArquivos(res.data);
  } catch (err) {
    alert('Erro ao carregar os arquivos.');
  }
};

useEffect(() => {
  carregarArquivos();
}, []);

const salvar = async () => {
  setCarregando(true);
  let caminhoFinal = '';

  try {
    // Upload do arquivo, se houver
    if (formulario.arquivo_real) {
      const formData = new FormData();
      formData.append('arquivo', formulario.arquivo_real);

      const upload = await axios.post(
        '/crm-wly/api/openai/ia_arquivos_disparos.php',
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );

      if (!upload.data.success) {
        alert('Erro ao enviar o arquivo: ' + upload.data.message);
        setCarregando(false);
        return;
      }

      caminhoFinal = upload.data.caminho;
    }

    // Montagem do payload
const payload = {
  ...formulario,
  caminho_arquivo: caminhoFinal || (modoEdicao ? arquivos.find(a => a.id === modoEdicao)?.caminho_arquivo || '' : ''),
  palavras_chave: formulario.palavras_chave
    .split(',')
    .map((p) => p.trim())
    .filter(Boolean)
};


    // PUT (editar) ou POST (novo)
    if (modoEdicao) {
      await axios.put(
        `/crm-wly/api/openai/ia_arquivos_disparos.php?id=${modoEdicao}`,
        payload,
        { headers: { 'Content-Type': 'application/json' } }
      );
    } else {
      await axios.post(
        '/crm-wly/api/openai/ia_arquivos_disparos.php',
        payload,
        { headers: { 'Content-Type': 'application/json' } }
      );
    }

    // Resetar formulário
    setFormulario({
      nome_arquivo: '',
      tipo_arquivo: 'pdf',
      palavras_chave: '',
      mensagem_confirmacao: '',
      mensagem_envio: '',
      arquivo_real: null
    });
    setModoEdicao(null);
    await carregarArquivos();
  } catch (err) {
    console.error(err);
    alert('Erro ao salvar o arquivo.');
  } finally {
    setCarregando(false);
  }
};

const editar = (arq) => {
  setModoEdicao(arq.id);
  setFormulario({
    nome_arquivo: arq.nome_arquivo,
    tipo_arquivo: arq.tipo_arquivo,
    palavras_chave: arq.palavras_chave.join(', '),
    mensagem_confirmacao: arq.mensagem_confirmacao,
    mensagem_envio: arq.mensagem_envio,
    arquivo_real: null
  });
};

const excluir = async (id) => {
  if (!window.confirm('Deseja excluir este arquivo?')) return;

  try {
    await axios.delete(`/crm-wly/api/openai/ia_arquivos_disparos.php?id=${id}`);
    await carregarArquivos();
  } catch (err) {
    alert('Erro ao excluir o arquivo.');
  }
};


return (
  <div className="arquivos-container">
    <div className="arquivos-flex-container">
    <div className="arquivos-form">
      {/* Primeira linha: nome + tipo */}
      <div className="arquivos-form-row">
        <input
          className="arquivos-input"
          placeholder="Nome do Arquivo"
          value={formulario.nome_arquivo}
          onChange={e => setFormulario({ ...formulario, nome_arquivo: e.target.value })}
        />
        <select
          className="arquivos-select"
          value={formulario.tipo_arquivo}
          onChange={e => setFormulario({ ...formulario, tipo_arquivo: e.target.value })}
        >           
          <option value="pdf">PDF</option>
          <option value="imagem">Imagem</option>
        </select>
      </div>

      {/* Segunda linha: palavras-chave */}
      <input
        className="arquivos-input-palavra"
        placeholder="Palavras-chave (separadas por vírgula)"
        value={formulario.palavras_chave}
        onChange={e => setFormulario({ ...formulario, palavras_chave: e.target.value })}
      />

      {/* Confirmação e Envio */}
      <textarea
        className="arquivos-textarea"
        placeholder="Mensagem de Confirmação"
        value={formulario.mensagem_confirmacao}
        onChange={e => setFormulario({ ...formulario, mensagem_confirmacao: e.target.value })}
      />
      <textarea
        className="arquivos-textarea"
        placeholder="Mensagem de Envio"
        value={formulario.mensagem_envio}
        onChange={e => setFormulario({ ...formulario, mensagem_envio: e.target.value })}
      />

      {/* Upload */}
      <input
        type="file"
        accept=".pdf,image/*"
        onChange={(e) => setFormulario({ ...formulario, arquivo_real: e.target.files[0] })}
        className="arquivos-upload"
      />

      {/* Botões */}
      <div className="arquivos-buttons">
        <button
          onClick={salvar}
          disabled={carregando}
          className={`arquivos-btn ${carregando ? 'arquivos-btn-disabled' : 'arquivos-btn-primary'}`}
        >
          {carregando ? 'Enviando...' : modoEdicao ? 'Atualizar' : 'Salvar'}
        </button>
        {modoEdicao && (
          <button
            onClick={() => {
              setModoEdicao(null);
              setFormulario({
                nome_arquivo: '',
                tipo_arquivo: 'pdf',
                palavras_chave: '',
                mensagem_confirmacao: '',
                mensagem_envio: '',
                arquivo_real: null
              });
            }}
            className="arquivos-btn-cancel"
          >
            Cancelar
          </button>
        )}
      </div>
      </div>

            <div className="arquivos-exemplos">
    <h4><strong>Exemplos úteis</strong></h4>
    <p><strong>Palavras-chave:</strong><br />proposta, pacotes, tratamentos, interesse em orçamento, quero contratar, tabela de preços</p>
    <p><strong>Mensagem de Confirmação:</strong><br /><strong>1. </strong>Temos um documento com nossos pacotes, posso lhe enviar?<br /><strong>2. </strong>Claro! Posso te enviar o material agora mesmo. Posso mandar?</p>
    <p><strong>Mensagem de Envio:</strong><br /><strong>1. </strong>Certo. Aqui está o documento com todos nossos pacotes. Avalie e me diga qual é melhor pra você.<br /><strong>2. </strong>Aqui está o material que você solicitou. Qualquer dúvida, é só me chamar!</p>
  </div>

    </div>



    {/* Tabela */}
    {arquivos.length > 0 ? (
      <table className="arquivos-table">
        <thead>
          <tr>
            <th>Nome</th>
            <th>Tipo</th>            
            <th>Palavras-chave</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {arquivos.map((arq) => (
            <tr key={arq.id}>
              <td>{arq.nome_arquivo}</td>
              <td>
                <a
                  href={arq.caminho_arquivo}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="arquivos-link"
                >
                  Baixar
                </a>
              </td>
              <td>{arq.palavras_chave.join(', ')}</td>
              <td>
                <div className="arquivos-actions">
                  <button onClick={() => editar(arq)} className="arquivos-btn arquivos-btn-primary">
                    Editar
                  </button>
                  <button onClick={() => excluir(arq.id)} className="arquivos-btn-cancel">
                    Excluir
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    ) : (
      <div className="arquivos-vazio">
        Nenhum arquivo encontrado.
      </div>
    )}
  </div>
);

}
